export var FileType;
(function (FileType) {
    FileType["IMAGE"] = "image";
    FileType["VIDEO"] = "video";
    FileType["DOCUMENT"] = "document";
    FileType["AUDIO"] = "audio";
    FileType["ARCHIVE"] = "archive";
    FileType["OTHER"] = "other";
})(FileType || (FileType = {}));
export var NotificationType;
(function (NotificationType) {
    NotificationType["RECIPE_LIKED"] = "recipe_liked";
    NotificationType["RECIPE_COMMENTED"] = "recipe_commented";
    NotificationType["USER_FOLLOWED"] = "user_followed";
    NotificationType["CREATOR_APPROVED"] = "creator_approved";
    NotificationType["PAYMENT_RECEIVED"] = "payment_received";
    NotificationType["SYSTEM_ANNOUNCEMENT"] = "system_announcement";
})(NotificationType || (NotificationType = {}));
